import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getPaymentAdditionalOption = (state: StateScheme) => {
    return state.payment.additionalOption
}
